import React, { useState, useRef } from "react";
import { LabelInput } from "./LabelInput";
import { FaArrowRight } from "react-icons/fa";
import WebsiteButton from "../../../../../components/core/button/WebsiteButton";
import { SupportedLanguage } from "../../../../../core/translations/supportedLanguages";
import { useLanguage } from "../../../../../core/translations/LanguageContext";
import { ContactTranslations } from './translations/types';
import { enTranslations } from './translations/en';
import { deTranslations } from './translations/de';

// Styled imports
import {
    Title,
    Description,
    Form,
    ButtonContainer,
    Message,
    ContactContainer,
    Container,
    SplitContainer,
    LeftColumn,
    RightColumn,
    BookDemo
} from "./ContactPage.styles";

const TRANSLATIONS: Record<SupportedLanguage, ContactTranslations> = {
    en: enTranslations,
    de: deTranslations,
};

const ContactPage: React.FC = ({
                                   //@ts-ignore
                                   pageTranslations
                               }) => {
    const { language } = useLanguage();
    const translations = TRANSLATIONS[language];
    const [sent, setSent] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const formRef = useRef<HTMLFormElement>(null);

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        const formData = new FormData(e.currentTarget);

        try {
            const response = await fetch('https://formspree.io/f/xjkyjkln', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                },
                body: formData,
            });

            if (response.ok) {
                console.log("Form sent successfully");
                setSent(true);
                setError(null);
                formRef.current?.reset();
                setTimeout(() => setSent(false), 5000); // Reset success message after 5 seconds
            } else {
                console.error('Failed to send form data', response.statusText);
                setError('Failed to send message. Please try again.');
            }
        } catch (error) {
            console.error('An error occurred while sending the form data', error);
            setError('An error occurred. Please try again later.');
        }
    };

    return (
        <ContactContainer>
            <Container>
                <SplitContainer>
                    {/* Left side: Contact Form */}
                    <LeftColumn>
                        <Title>Get in touch</Title>
                        <Description>
                            If you have a question or would like to get in touch, please send us a message using the form below.
                        </Description>
                        <Form ref={formRef} onSubmit={handleSubmit} method="POST">
                            <LabelInput label={translations.form.name} id="name" type="text" name="name" required />
                            <LabelInput label={translations.form.email} id="email" type="email" name="email" autoComplete="email" required />
                            <LabelInput
                                label={translations.form.helpMessage}
                                id="message"
                                type="textarea"
                                name="message"
                                ariaDescribedby="how-can-we-help-description"
                                rows={8}
                                //@ts-ignore
                                maxLength={500}
                                helperText={translations.form.charLimit}
                                required
                                defaultValue=""
                            />
                            <ButtonContainer>
                                {!sent && (
                                    <WebsiteButton type="submit" tag="button">
                                        {translations.form.submit}
                                    </WebsiteButton>
                                )}
                                {sent && <Message>{translations.form.thankYou}</Message>}
                                {error && <Message error>{error}</Message>}
                            </ButtonContainer>
                        </Form>
                    </LeftColumn>

                    {/* Right side: Book Demo */}
                    <RightColumn>
                        <Title>Book Your Demo</Title>
                        <Description>
                            Book your personalised demo today and explore how our platform can support your teaching goals.
                        </Description>
                        <BookDemo
                            href="https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ03BbH2Z0PQLj4GcZ3y5fBz_2DZGYtF2HQ6k6lSF6wF28yxXRMN130fQelY6M0-eweDqdX4Bv3G"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {`${pageTranslations.bookDemoTextForTestimonials}`}
                            <FaArrowRight />
                        </BookDemo>
                    </RightColumn>
                </SplitContainer>
            </Container>
        </ContactContainer>
    );
};

export default ContactPage;
